import React, { useContext, useRef } from 'react';

import styled from '@emotion/styled';

import useOutsideClick from '../../../hooks/ui-control/useOutsideClick';
import { TableContext } from '../TableContext';

interface IRightTableSlider {}

const RightTableSlider: React.FC<IRightTableSlider> = () => {
  const tableContext = useContext(TableContext);
  const containerRef = useRef<HTMLDivElement>(null);
  useOutsideClick(containerRef, () => tableContext?.setShowTableSlider(false));

  return (
    <Container
      ref={containerRef}
      className={tableContext?.showTableSlide ? 'reveal' : ''}
      aria-hidden={!tableContext?.showTableSlide}
      role='dialog'
      aria-label='Table details panel'
    >
      {tableContext?.sliderComp}
    </Container>
  );
};

export default RightTableSlider;

const Container = styled.div`
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 4000;
  width: 515px;
  transform: translateX(515px);
  transition: transform 0.3s ease-out;
  pointer-events: none;
  border-radius: 24px;

  &.reveal {
    transform: translateX(0px);
    pointer-events: auto;
    display: flex;
    box-shadow: 0 4px 28px 0 rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 884px) {
    display: none;
  }

  @media (max-width: 480px) {
    display: flex;
    width: 100vw;
  }
`;
